<template>
  <PageWrapper>
    <template #nav-routes>
      <div class="border-t border-gray-300 p-2">
        <LoadingSpinner v-if="!domainStore.domain" gray class="mt-2" />
        <div
          v-else-if="
            domainStore.domain.vendor_approved ||
            (domainStore.domain.agent.alias === 'zzzz' && userStore.isMirusUser)
          "
          id="editor-nav-items"
          class="flex flex-col gap-2"
        >
          <div
            class="py-2 text-left font-semibold uppercase leading-tight tracking-wider text-gray-600 overflow-clip text-ellipsis"
          >
            Editing {{ domainStore.domain?.name }}
          </div>
          <NavItem
            v-for="route in editorRoutes"
            :key="route.name"
            :to="{
              name: route.name,
              params: { domain: currentRoute.params.domain },
            }"
            :name="route.name"
            :icon="route.meta.icon"
          />
        </div>
      </div>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </PageWrapper>
</template>
<script setup>
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import NavItem from "@/components/NavItem.vue";
import PageWrapper from "@/components/PageWrapper.vue";
import useDomainStore from "@/stores/domain";
import useUserStore from "@/stores/user";

const router = useRouter();
const currentRoute = useRoute();

const domainStore = useDomainStore();
const userStore = useUserStore();

const editorRoutes = computed(() => {
  return router
    .getRoutes()
    .filter((route) => route.meta?.navGroup === "editor")
    .sort((a, b) => a.meta.navOrder - b.meta.navOrder);
});

onMounted(async () => {
  if (domainStore.domain?.name !== currentRoute.params.domain) {
    domainStore.clearData();
  }
  await domainStore.ensureDomain(currentRoute.params.domain);

  // force vendor selected for editor pages
  if (
    userStore.vendorKey === "all" &&
    domainStore.domain.agent.alias !== "zzzz"
  ) {
    router.push({
      name: "Domain Overview",
      params: { vendor: "all", domain: currentRoute.params.domain },
    });
  }
});
</script>
